import type { FunctionComponent } from 'react'
import React from 'react'

import type { ShowDateOrTime } from '../../../../types'
import styles from './DateTime.module.scss'

export const DateTime: FunctionComponent<DateProps> = ({
  dateInput,
  showDateOrTime = 'FullDateTime',
}) => {
  if (!dateInput) {
    return null
  }

  const d = new Date(dateInput)
  const year = d.getFullYear()
  const month = `${('0' + (d.getMonth() + 1)).slice(-2)}`
  const dayTwoDigits = (d.getDate() < 10 ? '0' : '') + d.getDate()

  const dateString = isFinite(d.getTime())
    ? `${dayTwoDigits} ${d.toLocaleString('en-GB', { month: 'short' })} ${year}`
    : null

  const hours = ('0' + d.getHours()).slice(-2)
  const mins = ('0' + d.getMinutes()).slice(-2)
  const seconds = ('0' + d.getSeconds()).slice(-2)
  const millisecond = d.getMilliseconds()

  const dateFormatNoTime = `${year}-${month}-${dayTwoDigits}`
  const dateFormatWithTime = `${dateFormatNoTime} ${hours}:${mins}:${seconds}:${millisecond}Z`

  const timeFormat = d
    .toLocaleString('en-GB', {
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h12',
    })
    .replace(/\s/g, '') //Removing space between time and am/pm

  if (!dateString) {
    return null
  }

  return (
    <div className={styles.date}>
      {showDateOrTime === 'Date' && (
        <time data-testid="date-only" className={styles.dateTime} dateTime={dateFormatNoTime}>
          {dateString}
        </time>
      )}

      {showDateOrTime === 'FullDateTime' && (
        <time
          className={styles.dateTime}
          dateTime={`${dateFormatWithTime}`}
          data-testid="full-date-and-time"
        >
          {`${dateString} ${timeFormat}`}
        </time>
      )}

      {showDateOrTime === 'Time' && (
        <time className={styles.dateTime} data-testid="time-only" dateTime={timeFormat}>
          {timeFormat}
        </time>
      )}
    </div>
  )
}

export type DateProps = {
  dateInput: Date | string | null
  /**
   * Show date or time only defaulted to 'FullDateTime'
   */
  showDateOrTime?: ShowDateOrTime
}
